import { render, staticRenderFns } from "./StartupTrackersPopup.vue?vue&type=template&id=677e3d3e&scoped=true&"
import script from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupTrackersPopup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StartupTrackersPopup.vue?vue&type=style&index=0&id=677e3d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e3d3e",
  null
  
)

export default component.exports